import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import apihost from "../../services/apihostname";

//Import module Modal
import Modal from "react-bootstrap/Modal";

// Import module Services
// import TambonService from "../../services/tambon.service";
import farmerService from "../../services/farmer.service";
// import AssocService from "../../services/assoc.service";
import authService from "../../services/auth.service";

// Import Form
import { Form, Col, Row, FormControl } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";

//Import module for datePicker
// import dayjs from "dayjs";
// import { WatDatePicker } from "thaidatepicker-react";

//Import ConfirmAlert
// import { confirmAlert } from "react-confirm-alert";

//Import loading
import LoadingAlert from "../../components/LoadingAlert";

//Import WebCam
// import Webcam from "../Farmer/Webcam";

//Import farmer.css
import "../Farmer/farmer.css";
import assocService from "services/assoc.service";

// const valid = {
//   display: "block",
//   width: "100%",
//   padding: "0.375rem 0.75rem",
//   fontSize: "1rem",
//   fontWeight: 400,
//   lineHeight: 1.5,
//   color: "#212529",
//   backgroundColor: "#fff",
//   backgroundClip: "padding-box",
//   border: "1px solid #ced4da",
//   appearance: "none",
//   borderRadius: "0.25rem",
//   transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
// };

// const invalid = {
//   display: "block",
//   width: "100%",
//   padding: "0.375rem 0 0.375rem",
//   fontSize: "1rem",
//   fontWeight: 400,
//   lineHeight: 1.5,
//   color: "#212529",
//   backgroundColor: "#fff",
//   backgroundClip: "padding-box",
//   border: "1px solid #dc3545",
//   appearance: "none",
//   borderRadius: "0.25rem",
//   transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
//   paddingRight: "calc(1.5em + 0.75rem)",
//   backgroundImage:
//     'url(\'data:image/svg+xml,%3csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width="12" height="12" fill="none" stroke="%23dc3545"%3e%3ccircle cx="6" cy="6" r="4.5"/%3e%3cpath stroke-linejoin="round" d="M5.8 3.6h.4L6 6.5z"/%3e%3ccircle cx="6" cy="8.2" r=".6" fill="%23dc3545" stroke="none"/%3e%3c/svg%3e\')',
//   backgroundRepeat: "no-repeat",
//   backgroundPosition: "right calc(0.375em + 0.1875rem) center",
//   backgroundSize: "calc(0.75em + 0.375rem) calc(0.75em + 0.375rem)",
// };

function ModalEditMember(props) {
  // const [hiddenCamera, setHiddenCamera] = useState(true);
  const [loadAlert, setLoadAlert] = useState(false);
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [farmer, setFarmer] = useState([]);
  // const [proselect, setProselect] = useState("0");
  const [image, setImage] = useState({ preview: "", raw: "" });
  // const [hiddenprename, setHiddenprename] = useState(true);
  // const [amp, setAmp] = useState([]);
  // const [tam, setTam] = useState([]);

  const user = authService.getCurrentUser();

  // const user = JSON.parse(sessionStorage.getItem("user"));
  const handleClose = () => {
    initialForm();
    setErrors({});
    props.hidden(false);
    props.setassocmember({});
  };

  const initialForm = () => {
    // setSelectedDate("");
    // setHiddenprename(true);
    setForm({});
    setFarmer({});
    setErrors({});
  };
  useEffect(() => {
    // console.log(props.data);
    if (props.data) {
      farmerService.getFarmerById(props.data.cardid).then((data) => {
        if (data.data.success) {
          const status = data.data.farmer.status ? "มีชีวิต" : "เสียชีวิต";
          const birthdate = new Date(data.data.farmer.birth_date);
          // console.log(birthdate);
          setImage({
            preview:
              apihost + "/images/farmer/" + data.data.farmer.farmer_image,
          });
          setFarmer({
            ...data.data.farmer,
            ["birth_date"]: birthdate.toLocaleString("th-TH", {
              year: "numeric",
              month: "long",
              day: "numeric",
            }),
            cardid: props.data.cardid,
            status: status,
            sex: data.data.farmer.sex,
            tel: data.data.farmer.tel,
            pre_name: data.data.farmer.pre_name,
            address: data.data.farmer.farmer_address,
            prov: data.data.farmer.prov_namt,
            amp: data.data.farmer.amp_namt,
            tam: data.data.farmer.tam_namt,
          });
          setForm({
            associd: props.data.associd,
            memberid: props.data.memberid,
            assocname: props.data.assocname,
            membercode: props.data.membercode,
            statusmember: props.data.statusmember,
            userid: user.user.user_id,
          });
          // console.log(props.assoc_selected);
          // console.log(form);
        } else {
          alert(data.data.message);
        }
      });
    }
  }, [props.data]);
  // console.log(form);

  // function checkID(id) {
  //   if (id.length != 13) return false;
  //   let sum = 0;
  //   for (let i = 0; i < 12; i++) {
  //     sum += parseFloat(id.charAt(i)) * (13 - i);
  //   }
  //   if ((11 - (sum % 11)) % 10 != parseFloat(id.charAt(12))) return false;

  //   return true;
  // }

  const setField = (field, value) => {
    // if (field.name == "membercode") {
    //   console.log(!checkID(value));
    //   if (value.length != 13) {
    //     setErrors({ ...errors, [field.name]: "กรอกเลขบัตรไม่ครบ" });
    //   } else if (!checkID(value)) {
    //     setErrors({ ...errors, [field.name]: "เลขบัตรไม่ถูกต้อง" });
    //   } else {
    //     setErrors({ ...errors, [field.name]: null });
    //   }
    // }
    setForm({
      ...form,
      [field.name]: value,
    });
    if (errors[field.name] && field.name != "id_card")
      setErrors({
        ...errors,
        [field.name]: null,
      });
    // }
    console.log(form);
  };
  const findFormErrors = () => {
    console.log(form);
    // const { membercode, statusmaster, pre_other, first_name } = form;
    const newErrors = {};

    // // check card error
    // if (!id_card || id_card === "") newErrors.id_card = "กรุณากรอกบัตรประชาชน";
    // // else if (usertype.length > 2) newErrors.usertype = "name is too long!";

    // // prename errors
    // if (!pre_name || pre_name === "0") {
    //   newErrors.pre_name = "กรุณาเลือกคำนำหน้า";
    // } else if (pre_name === "อื่นๆ" && (pre_other === "" || !pre_other)) {
    //   newErrors.pre_other = "กรุณากรอกคำนำหน้า";
    // }

    // // firstname
    // if (!first_name || first_name === "")
    //   newErrors.first_name = "กรุณากรอกชื่อ";

    return newErrors;
  };

  const handleSubmit = (e) => {
    console.log(form);
    e.preventDefault();
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      alert(newErrors);
      setErrors(newErrors);
    } else {
      setLoadAlert(true);
      // form.user_id = user.user.user_id;
      // const data = new FormData();
      // for (const key in form) {
      //   data.append(key, form[key]);
      // }
      // const newform = {
      //   associd: props.data.associd,
      //   memberid: props.data.memberid,
      //   farmerstatus: form.farmerstatus,
      //   membercode: form.membercode,
      //   statusmaster: form.statusmaster,
      //   userid: user.user.user_id,
      // };
      assocService
        .updateMember(form)
        .then((response) => {
          console.log(response.data);
          if (response.data.success) {
            console.log(props.data);
            var newArray = props.memberdata.map(function (el) {
              if (el.memberid != response.data.data.memberid) {
                return el;
              } else {
                var check = response.data.data;
                return check;
              }
            });
            props.setdata([...newArray]);
            // setLoadAlert(true);
            alert("ปรับปรุงข้อมูลเรียบร้อย !");
            initialForm();
          } else {
            alert(response.data.message);
          }
        })
        .catch((error) => {
          alert(error);
          console.log(error);
        })
        .finally(() => {
          console.log(false);
          props.hidden(false);
          setLoadAlert(false);
        });
    }
  };

  return (
    <>
      {loadAlert ? <LoadingAlert /> : ""}
      <Modal size="lg" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>แก้ไขข้อมูล</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>
            สมาชิกสมาคม : {user.user.member_type !== 4 ? form.assocname : ""}
          </h4>
          <Form>
            <Row>
              <Col md="6">
                <Form.Group>
                  <Form.Label>เลขสมาชิก</Form.Label>
                  <FormControl
                    type="number"
                    name="membercode"
                    value={form.membercode}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.membercode}
                    // disabled={true}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.membercode}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>สถานภาพ</Form.Label>
                  <Form.Select
                    name="statusmember"
                    value={form.statusmember}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.statusmember}
                    // disabled={true}
                  >
                    <option value="">เลือก...</option>
                    <option value="เป็นสมาชิก">เป็นสมาชิก</option>
                    <option value="ลาออก">ลาออก</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.statusmember}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <hr />
            <Row>
              <h4>ข้อมูลชาวไร่อ้อย</h4>
              <table className="table-bordered smooth align-left">
                <tbody>
                  <tr>
                    <th scope="col">ข้อมูล</th>
                    <th scope="col">รายละเอียด</th>
                  </tr>
                  <tr>
                    <th>รูปภาพ</th>
                    <td>
                      <div className="uploadpic">
                        <label htmlFor="upload-button">
                          {image.preview ? (
                            <img
                              src={image.preview}
                              alt="No Image"
                              width="150"
                              height="150"
                            />
                          ) : (
                            ""
                          )}
                        </label>
                      </div>
                    </td>
                  </tr>
                  {user.user.member_type !== 4 ? (
                    <tr>
                      <th>สมาคม</th>
                      <td>{form.assocname}</td>
                    </tr>
                  ) : (
                    ""
                  )}
                  <tr>
                    <th>ชื่อ-สกุล</th>
                    <td>
                      {(farmer.pre_name ? farmer.pre_name : farmer.pre_other) +
                        " " +
                        farmer.first_name +
                        " " +
                        farmer.last_name}
                    </td>
                  </tr>
                  <tr>
                    <th>หมายเลขบัตรประชาชน</th>
                    <td>{farmer.cardid}</td>
                  </tr>
                  <tr>
                    <th>สถานะการมีชีวิต</th>
                    <td>{farmer.status}</td>
                  </tr>
                  <tr>
                    <th>เกิดวันที่</th>
                    <td>{farmer.birth_date}</td>
                  </tr>
                  <tr>
                    <th>เพศ</th>
                    <td>{farmer.sex}</td>
                  </tr>
                  <tr>
                    <th>ที่อยู่</th>
                    <td>
                      {(farmer.address ? farmer.address : "") +
                        " " +
                        farmer.tam +
                        " " +
                        farmer.amp +
                        " " +
                        farmer.prov}
                    </td>
                  </tr>
                  <tr>
                    <th>โทร.</th>
                    <td>{farmer.tel}</td>
                  </tr>
                </tbody>
              </table>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-warning" onClick={handleClose}>
            ยกเลิก
          </button>
          <button
            className="btn btn-primary"
            type="submit"
            onClick={handleSubmit}
          >
            ตกลง
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalEditMember;

ModalEditMember.propTypes = {
  show: PropTypes.bool,
  hidden: PropTypes.func,
  data: PropTypes.object,
  memberdata: PropTypes.array,
  setdata: PropTypes.func,
  setassocmember: PropTypes.func,
  // assoc_selected: PropTypes.object,
  // userid: PropTypes.number,
};
ModalEditMember.defaultProps = {
  data: [],
  // assoc_selected: [],
};
